import markUrl from "@/assets/redvolt-logo.webp";
import { cn } from "@/lib/utils";

// Standalone brand mark — favicon, collapsed sidebar, compact header, avatar,
// loading/brand state. Preserve aspect ratio; never stretch/rotate/recolor.
export const BrandMark = ({ size = 32, className, ...props }) => (
  <img
    src={markUrl}
    alt="RedVolt"
    width={size}
    height={size}
    className={cn("shrink-0 object-contain", className)}
    style={{ width: size, height: size }}
    data-testid="redvolt-mark"
    {...props}
  />
);

// Primary horizontal lockup — [mark] REDVOLT.
export const LogoLockup = ({ markSize = 30, className, wordClassName }) => (
  <span className={cn("inline-flex items-center gap-2.5 select-none", className)} data-testid="redvolt-lockup">
    <BrandMark size={markSize} />
    <span
      className={cn(
        "font-display font-bold tracking-tight text-slate-900 text-xl leading-none",
        wordClassName
      )}
    >
      RedVolt
    </span>
  </span>
);
